import React from 'react';

/**
 * Floating WhatsApp chat button.
 * Opens a WhatsApp conversation with Consultium Group in a new tab.
 * Uses wa.me (works across desktop web, mobile web and the WhatsApp app).
 */
const WHATSAPP_NUMBER = '27790424911'; // +27 79 042 4911 (no + or spaces for wa.me)
const DEFAULT_MESSAGE = encodeURIComponent(
  "Hi Consultium Group, I'd like to chat about your services."
);

const ChatBot = () => {
  const href = `https://wa.me/${WHATSAPP_NUMBER}?text=${DEFAULT_MESSAGE}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="nofollow noopener noreferrer"
      title="Chat with us on WhatsApp"
      data-testid="floating-whatsapp-btn"
      className="fixed bottom-6 right-6 z-50 flex items-center gap-2 rounded-full bg-[#25D366] px-4 py-3 text-white shadow-lg shadow-emerald-600/30 transition-all hover:scale-105 hover:bg-[#1ebe5b] focus:outline-none focus:ring-4 focus:ring-emerald-300"
    >
      <span className="relative flex h-6 w-6 items-center justify-center">
        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-white/40 opacity-60"></span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 32 32"
          className="relative h-6 w-6 fill-white"
          aria-hidden="true"
        >
          <path d="M19.11 17.24c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.65.07-.3-.15-1.25-.46-2.38-1.47-.88-.79-1.47-1.76-1.64-2.06-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.49 0 1.47 1.07 2.89 1.22 3.09.15.2 2.1 3.21 5.1 4.5.71.31 1.27.49 1.7.63.71.23 1.36.2 1.87.12.57-.08 1.76-.72 2.01-1.42.25-.7.25-1.29.17-1.42-.07-.13-.27-.2-.57-.35zM16.02 3.2C9.4 3.2 4.03 8.57 4.03 15.19c0 2.11.55 4.17 1.6 5.99L4 27.2l6.16-1.61a11.94 11.94 0 0 0 5.86 1.5h.01c6.62 0 11.99-5.37 11.99-11.99 0-3.2-1.25-6.21-3.51-8.47a11.9 11.9 0 0 0-8.49-3.43zm0 21.83h-.01a9.94 9.94 0 0 1-5.07-1.39l-.36-.22-3.66.96.98-3.57-.24-.37a9.94 9.94 0 0 1-1.53-5.28c0-5.5 4.48-9.98 9.98-9.98 2.66 0 5.17 1.04 7.06 2.93a9.9 9.9 0 0 1 2.92 7.06c0 5.5-4.48 9.98-9.97 9.98z" />
        </svg>
      </span>
      <span className="hidden text-sm font-semibold sm:inline">Chat on WhatsApp</span>
    </a>
  );
};

export default ChatBot;
